import * as css from './LecturesBoard.css';
import LectureTile from '../LectureTile/LectureTile';
import {TTimeGroup} from '../../useTimetableSalesData';

function LecturesBoard({timeGroups}: {timeGroups: TTimeGroup[]}) {
    return (
        <css.board>
            {timeGroups.map(([time, lectures]) => (
                <css.boardRow key={time}>
                    <css.timePill>
                        <css.timeText>{time}</css.timeText>
                    </css.timePill>
                    <css.tiles>
                        {lectures.map(l => <LectureTile key={l.ttid} lecture={l} />)}
                    </css.tiles>
                </css.boardRow>
            ))}
        </css.board>
    );
}
export default LecturesBoard;
